export default __webpack_public_path__ + "static/media/img10.09a65584.jpg";